import { render, staticRenderFns } from "./AssignedProjectTranslator.vue?vue&type=template&id=172b4a5c&scoped=true&"
import script from "./AssignedProjectTranslator.vue?vue&type=script&lang=js&"
export * from "./AssignedProjectTranslator.vue?vue&type=script&lang=js&"
import style0 from "./AssignedProjectTranslator.vue?vue&type=style&index=0&id=172b4a5c&prod&lang=css&"
import style1 from "./AssignedProjectTranslator.vue?vue&type=style&index=1&id=172b4a5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b4a5c",
  null
  
)

export default component.exports